import React, { useEffect, useState, useRef } from "react";
import ArenaLogo from "../../assets/images/ArenaLogoBrandNew.png";
import maacLogo from "../../assets/images/maac-logoBrandNew.png";
import LakmeLogo from "../../assets/images/LakmeLogoBrand.png";
import aptechLearningLogo from "../../assets/images/aptechLearningLogoBrand.png";
import individualTraining_Banner from "../../assets/images/individualTraining Bannner.png";
import AvgcImg from "../../assets/images/AvgcImg.jpg";
import BeautyImg from "../../assets/images/BeautyImg.png";
import ITImage from "../../assets/images/ITImage.jpg";
import virtualProductionNew from "../../assets/images/virtualProductionNew.jpg";
import styles from "../OurBussiness/IndividualBusiness.module.scss";
import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import arenaAnimationImg from "../../assets/images/arenaAnimationImg.jpg";
import aptechaviationImg from "../../assets/images/aptechaviationImg.jpg";
import aviationAcademyNewLogo from "../../assets/images/aviationAcademyNewLogo.png";
import virtualProductionLogoNew from "../../assets/images/virtualProductionLogoNew.png";
import { motion } from "framer-motion";
import avalonImage from "../../assets/images/avalonImage.png";
import preschoolImage from "../../assets/images/preschoolImage.png";
import preschoolLogo from "../../assets/images/preschoolLogo.png";
import MetaComponent from "../CommonComponents/MetaComponent.tsx";
const IndividualBusiness: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Our Businesses", link: "/our-businesses" },
    { title: "Domestic Retail", link: "" },
  ];

  return (
    <div className={styles.OverviewBusinessPage}>
      <MetaComponent
        title="Vocational Training Courses & Career Education Programs | Aptech Limited"
        desc="Boost your career with Aptech Limited’s certified vocational training courses and career education programs designed to meet global industry standards."
      />
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <Banner />
      </motion.div>

      <IndividualTraining />
    </div>
  );
};

export default IndividualBusiness;

const Banner: React.FC = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsTablet(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container">
      {!isTablet ? (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">Domestic Retail</p>
              <p className={`${styles.desc} para`}>
                Aptech's Domestic Retail division offers a diverse range of{" "}
                <strong>vocational courses</strong> across various high-demand
                sectors, empowering students with industry-relevant skills for{" "}
                <strong>successful careers</strong> and{" "}
                <strong>professional growth</strong>. By focusing on vocational
                jobs in demand, our programs and training methodologies ensure
                that learners are equipped with skills required to excel in
                today's competitive job market.
              </p>
              <p className={`${styles.desc} para`}>
                Our key training verticals include:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 col-sm-12 col-xs-12 d-flex`}
            >
              <img
                src={"/images/young-executive-working-with-documents.png"}
                alt="Young Professional In Formal Attire Checking Clipboard"
                title="Confident Team Member Reviewing Key Documents"
                className={classNames(styles.BusinessBannerTwo, "img-fluid")}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">Domestic Retail</p>
              <p className={`${styles.desc} para`}>
                Aptech's Domestic Retail division offers a diverse range of{" "}
                <strong>vocational courses</strong> across various high-demand
                sectors, empowering students with industry-relevant skills for{" "}
                <strong>successful careers</strong> and{" "}
                <strong>professional growth</strong>. By focusing on vocational
                jobs in demand, our programs and training methodologies ensure
                that learners are equipped with skills required to excel in
                today's competitive job market.
              </p>
              <p className={`${styles.desc} para`}>
                Our key training verticals include:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 d-flex`}
            >
              <img
                src={"/images/young-executive-working-with-documents.png"}
                alt="Young Professional In Formal Attire Checking Clipboard"
                title="Confident Team Member Reviewing Key Documents"
                className={`${styles.BusinessBannerOne} img-fluid col-md-6`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const IndividualTraining: React.FC = () => {
  interface DataItem {
    src: string;
    title: string;
    description: string;
    logo: string;
    websiteUrl: string;
  }
  const data: DataItem[] = [
    {
      src: arenaAnimationImg,
      title: "Arena Animation",
      description:
        "Established in 1996, Arena Animation is a legacy brand of Aptech Ltd. It offers specialized courses in Animation, VFX, Game Design, Broadcast, and Digital Design, designed for both aspiring creators and seasoned professionals. Arena Animation has established a strong global footprint, making its world-class education accessible to lakhs of students and professionals in India and abroad. Backed by over 3 lakh successful placements, Arena Animation continues to shape the future of the animation and multimedia industry.",
      logo: ArenaLogo,
      websiteUrl: "https://www.arena-multimedia.com/in/en/",
    },
    {
      src: AvgcImg,
      title: "Maya Academy of Advanced Creativity (MAAC)",
      description:
        "One of Aptech's leading media and entertainment training brands, dedicated to delivering world-class training in Animation, VFX, Gaming, Filmmaking and Digital Design. Established in 2001, MAAC has become a leading name in media and entertainment training, offering a broad spectrum of career-focused programs. With a strong pan-India network, MAAC has trained thousands in industry-ready skills for careers in the creative sector.",
      logo: maacLogo,
      websiteUrl: "https://www.maacindia.com/",
    },
    {
      title: "Lakmē Academy Powered by Aptech",
      src: BeautyImg,
      description:
        "In partnership with Lakmē, we launched Lakmē Academy Powered by Aptech with the mission to provide comprehensive courses in cosmetology, makeup, hair styling, skin care, and personal grooming. Incorporating both theory and practical classes, these programs are designed to prepare students for glamorous careers in the fashion, beauty and wellness, and wellness industry.",
      logo: LakmeLogo,
      websiteUrl: "https://www.lakme-academy.com/",
    },
    {
      title: "Avalon Academy",
      src: aptechaviationImg,
      description:
        "A state-of-the-art aviation, hospitality, and luxury retail training academy delivering job-oriented courses in aviation, hospitality, travel & tourism, event management, and luxury retail. Our training programs equip students with the necessary skills to excel in booming industries. By emphasizing hands-on learning and real-world applications, we provide our students with ample career growth opportunities in their chosen fields.",
      logo: avalonImage,
      websiteUrl: "https://www.aptechaviationacademy.com/",
    },
    {
      title: "Aptech Learning",
      src: ITImage,
      description:
        "A well-known and much sough-after IT training institute offering comprehensive IT courses, ranging from foundational programs to advanced certifications. The courses cover areas such as software development, hardware and networking, AI and ML, cybersecurity. These are designed to meet industry standards, ensuring students excel in their respective fields and can compete in the dynamic tech landscape.",
      logo: aptechLearningLogo,
      websiteUrl: "https://www.aptechlearning.com/",
    },
    {
      title: "The Virtual Production Academy",
      src: virtualProductionNew,
      description:
        "Backed up by Aptech’s 27 years of experience in media and entertainment training that’s aligned with the latest industry requirements, we launched India’s first virtual production unit, The Virtual Production Academy in Mumbai, India. The academy trains students in virtual production and in the new craft of film making, helping them prepare themselves as seasoned professionals ready to face the dynamic media industry.",
      logo: virtualProductionLogoNew,
      websiteUrl: "https://thevirtualproductionacademy.com/",
    },
    {
      title: "Aptech International Preschool",
      src: preschoolImage,
      description:
        "A leading preschool chain in India that strives to create a smart, secure and stimulating learning environment for every child. Modern-day preschool programs, finest pedagogy and an internationally acclaimed curriculum offered by the preschool focus on the holistic development of children. We provide age-specific lesson plans for the pre-schoolers so that they can earn the right skills as they grow.",
      logo: preschoolLogo,
      websiteUrl: "https://www.aptechinternationalpreschool.com/",
    },
  ];

  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false)
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" } // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);

  return (
    <div className="container">
      <div className={`${styles.IndividualTraining} section`}>
        <div className={styles.EBGData}>
          {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.2,
                }}
                className={`row g-0 justify-content-center ${styles.EbgCardRow}`}
              >
                <div className={`col-lg-2 col-md-12 ${styles.EBGImgDiv}`}>
                  <img
                    src={item.src}
                    alt="Aptech Logo"
                    className={`${styles.logoImage} img-fluid`}
                  />
                </div>
                <div className="col-lg-10 col-md-12">
                  <div
                    className={`d-flex flex-column justify-content-end align-items-start ${styles.EbgDataContent}`}
                  >
                    {item.logo && (
                      <img
                        src={item.logo}
                        alt="Aptech Logo"
                        className={`${styles.logo}`}
                      />
                    )}
                    <h6
                      className={`${styles.contentTitle} caps subHeading mb-2 `}
                    >
                      {item.title}
                    </h6>

                    <p
                      className={`${styles.contentDescription} para`}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    <button
                      className={`secondary-btn para ${styles.buttonStyle}`}
                      onClick={() => {
                        window.open(item.websiteUrl, "_blank");
                      }}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
      <motion.div
        ref={(el) => (sectionRefs.current[data.length] = el)}
        initial={{ opacity: 0, y: 100 }}
        animate={hasAnimated[data.length] ? { opacity: 1, y: 0 } : {}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          delay: data.length * 0.2,
        }}
        className={`row ${styles.paragraphBottom}`}
      >
        <div className="col-12">
          <p className="para">
            Through the Domestic Retail business, <a href="/">Aptech</a> has{" "}
            <strong>trained millions of students</strong> worldwide, providing
            them with
            <strong> industry-relevant skills</strong> that are aligned with
            vocational jobs in demand. Our commitment to{" "}
            <strong>quality education</strong> and{" "}
            <strong>skill development </strong>
            ensures that our students are well-equipped to meet industry demands
            and excel in their{" "}
            <a href="/careers-with-aptech">
              <strong>careers</strong>
            </a>
            .
          </p>
        </div>
      </motion.div>
    </div>
  );
};
